import React from "react";
import Signup from "../screens/Account/Signup";
import Layout from "../layouts/GeneralLayout";
const MobileSignupPage = () => (
  <Layout>
    <Signup />
  </Layout>
);
export default MobileSignupPage;
